import { MouseEventHandler, useCallback } from 'react';

export const useAnchorHandler = (anchor: string) => {
  const anchorHandler: MouseEventHandler<HTMLElement> = useCallback(
    (e) => {
      e.preventDefault();
      const element = document.getElementById(anchor);

      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    },
    [anchor]
  );

  return anchorHandler;
};
